import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import queryString from 'query-string';
import { t } from '../../locales';
import { validateEmail } from 'mytime-common/forms/validate-email.js';

import {
  findClient,
  setClientNotFound,
  setHasServicesForClient,
} from '../../data/client/ClientActions.js';
import { getClasses } from '../../data/classes/ClassActions.js';
import {
  ThemedButton,
  Backdrop,
} from '../../components/Themed.js';
import './ClientInformation.css';

class ClientInformation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneOrEmail: '',
      isNoClassSessionsFound: false,
      submitting: false,
      isClientOverrideFlow: false,
      redirectUrl: null,
      shouldRender: false,
    };

    this.goClick = this.goClick.bind(this);
    this.isValidPhone = this.isValidPhone.bind(this);
    this.goToUrl = this.goToUrl.bind(this);
  }

  async componentDidMount() {
    this.props.setClientNotFound(false);

    const urlParams = queryString.parse(window.location.search);

    if (urlParams.phoneOrEmail) {
      this.setState({ phoneOrEmail: urlParams.phoneOrEmail });
    }

    if (urlParams.clientId) {
      this.setState({
        isClientOverrideFlow: true,
        clientIdOverride: urlParams.clientId,
        shouldRender: false,
      });
      await this.goClick(urlParams.clientId);
    } else {
      this.setState({ isClientOverrideFlow: false, shouldRender: true });
    }
  }

  goToUrl(url) {
    const { history } = this.props;
    const { isClientOverrideFlow } = this.state;

    if (isClientOverrideFlow) {
      this.setState({
        redirectUrl: url,
      });
    } else {
      history.push(url);
    }
  }

  async goClick(clientIdOverride = null) {
    const {
      findClient,
      getClasses,
    } = this.props;

    this.setState({
      submitting: true,
    });

    const phoneOrEmail = this.state.phoneOrEmail;
    let result = false;

    if (clientIdOverride) {
      result = true;
    } else {
      const findResult = await findClient(phoneOrEmail);
      if (findResult.clients.length > 1) {
        this.goToUrl(
          `/clientSelection?phoneOrEmail=${phoneOrEmail}${
            this.props.isCheckingIn ? '&isCheckingInClass=true' : ''
          }`
        );
        return;
      }
      result = findResult.found;
    }

    if (result) {
      getClasses(
        this.props.location.id,
        this.props.clientInformation.id
      ).then(result => {
        if (result) {
          this.goToUrl('/classes');
        } else {
          this.setState({ isNoClassSessionsFound: true });
        }
      })
      .catch(() => {
        this.setState({ isNoClassSessionsFound: true });
      });
    }

    this.setState({ submitting: false, shouldRender: true });
  }

  isValidPhone(str) {
    const strNumbers = str.replace(/\D+/g, '');
    const sequence = '() -0123456789';
    const length = 10;

    for (let i = 0; i < strNumbers.length; i++) {
      const c = strNumbers[i];
      if (sequence.indexOf(c) === -1) {
        return false;
      }
    }

    const { businessInfo } = this.props;
    if (businessInfo.company.locale_uuid !== 'en') {
      return strNumbers.length >= 6;
    }

    return strNumbers.length === length;
  }

  render() {
    const { redirectUrl, shouldRender } = this.state;

    if (redirectUrl) {
      return <Redirect to={redirectUrl} />;
    }

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />

        <div className="scroll-container content-container">
          <div className="page-container">
            {shouldRender && (
              <div className="return-client">
                <div className="client-information-title">
                  {t('client_information.please_enter_your_information')}.
                </div>
                <div className="content-medium-wide enlarged-width">
                  <div className="client-information-note">
                    {t(
                      'client_information.enter_your_phone_number_or_email_address'
                    )}
                  </div>
                  <div className="client-information-input-group">
                    <input
                      className="client-information-input"
                      placeholder={t(
                        'client_information.enter_your_phone_number_or_email_address'
                      )}
                      value={this.state.phoneOrEmail}
                      onChange={e =>
                        this.setState({ phoneOrEmail: e.target.value })
                      }
                    />
                    <ThemedButton
                      className="client-information-addon"
                      disabled={
                        this.state.phoneOrEmail === '' ||
                        !(
                          validateEmail(this.state.phoneOrEmail) ||
                          this.isValidPhone(this.state.phoneOrEmail)
                        ) ||
                        this.state.submitting
                      }
                      onClick={() => this.goClick(false)}
                    >
                      Go
                      {this.state.submitting && (
                        <React.Fragment>
                          {' '}
                          <i className="fas fa-spinner fa-pulse" />
                        </React.Fragment>
                      )}
                    </ThemedButton>
                  </div>
                  {this.props.isCheckingIn && (this.props.isClientNotFound || this.state.isNoClassSessionsFound) && (
                    <div>
                      <div className="client-information-error-message">
                        {t(
                          'client_information.sorry_we_couldnt_find_any_class_for_you_today'
                        )}
                        <br />
                        {t('client_information.please_try_again')}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isNewClient: state.client.isNewClient,
    isClientNotFound: state.client.isClientNotFound,
    clientInformation: state.client.clientInformation,
    businessInfo: state.app.businessInfo,
    location: state.app.location,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      findClient,
      getClasses,
      setClientNotFound,
      setHasServicesForClient,
    }
  )(ClientInformation)
);
